<template>
    <v-card class="px-3 py-0 py-lg-2 mb-md-2 mb-0" style="position: sticky; top: -1pt; z-index: 5; background: rgba(255, 0, 0, 0.0); backdrop-filter: blur(15px)" outlined>
        <v-simple-table>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="pa-0 pa-sm-1 pa-lg-2" :style="{width: $vuetify.breakpoint.mdAndUp || $vuetify.breakpoint.xs ? '11.11%' : '15%'}" style="border-bottom: 0pt"></th>
                        <th v-for="lesson in lessons" :key="'th-' + lesson.id" class="pa-0 pa-sm-1 pa-lg-2" :style="{width: $vuetify.breakpoint.mdAndUp || $vuetify.breakpoint.xs ? '11.11%' : '10.625%'}" style="text-align:center; border-bottom: 0pt; white-space: nowrap">
                            {{ lesson.day.slice(0, 3) }}
                            <br>
                            {{ $vuetify.breakpoint.xs ? lesson.start_time : lesson.start_time + '&ndash;' + lesson.end_time }}
                        </th>
                    </tr>
                </thead>
            </template>
        </v-simple-table>
    </v-card>
</template>

<script>

export default {
    name: 'LessonsTableHeader',
    props: {
        lessons: Array[Object]
    },
    data: () => ({
    }),
    computed: {
    },
    methods: {
    }
}

</script>

<style lang="scss">
.v-data-table {
    background: rgba(0, 0, 0, 0.0) !important;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    color: rgba(0,0,0,0.8);
}
table {
    table-layout: fixed !important;
}
</style>
